import { render, staticRenderFns } from "./Bearbeitung_Fail.vue?vue&type=template&id=4fbaeb9b&scoped=true"
import script from "./Bearbeitung_Fail.vue?vue&type=script&lang=js"
export * from "./Bearbeitung_Fail.vue?vue&type=script&lang=js"
import style0 from "./Bearbeitung_Fail.vue?vue&type=style&index=0&id=4fbaeb9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbaeb9b",
  null
  
)

export default component.exports